export * from './chip-list.module';
export * from './directives/chip-list-expand.directive';
